<template>
    <div id="device-sort">
        <hr class="separator separator--gray4">
        <ob1-radio-button-list
            class="ms-1"
            :radios-buttons="sortRadioButtons"
            @change="sortMobilesSelected"
        />
    </div>
</template>
<script>

export default {
    name: "DeviceSort",
    components: {

    },
    props: {
        sortRadioButtons: {
            type: Array,
            required: true
        },
    },
    computed: {

    },
    methods: {
        sortMobilesSelected(sortId) {
            Tms.link({category: "selecteur_produit", action: sortId, label: "trier_par"});
            let selectedSort = this.sortRadioButtons.find(sort => sort.radioButtonDTO.id === sortId)
            if (selectedSort) {
                this.$emit('sort-item-click', selectedSort.radioButtonDTO.value);
            }
        }
    }
};
</script>
